import React, {Component} from 'react';
import OcenyPojazdowTable from "./OcenyPojazdowTable";


export default class OcenyPojazdowTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {

        return (
            <div>
                <OcenyPojazdowTable data={this.props.ocenyPojazdow}/>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/oceny/components/OcenyPojazdowTab.js